import React, { FC, useCallback, useEffect, useState } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { Description, MainHeadline } from 'components/Typography'
import { NavButton, OrangeButton } from 'components/Button'
import { DndBreadList, DndWrapper } from 'components/Dnd'
import { Tabs } from 'components/Tab'
import { useDispatch, useSelector } from 'react-redux'
import { fetchBreads, saveBreadsOrder } from 'reducks/bread/operations'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'
import { getStoreRef } from 'reducks/auth/selectors'
import { useDndItems } from 'hooks/bread'
import { MoveHandler } from 'types/dnd'
import { StockUnionType } from 'types/stock'

const ProductOrderTemplate: FC = () => {
  const dispatch = useDispatch()

  const breads = useSelector((state: State) => getBreads(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))

  const [page, setPage] = useState<StockUnionType>('daily')
  const [isEdited, setEdited] = useState<boolean>(false)
  const [items, setItems] = useDndItems(breads)

  const moveItem: MoveHandler = useCallback(
    (dragIndex: number, targetIndex: number) => {
      // dragIndexとtargetIndexからswap処理
      const item = items[dragIndex]
      if (!item) return
      setItems((prevState) => {
        const newItems = prevState.filter((_, i) => i !== dragIndex)
        newItems.splice(targetIndex, 0, { ...item })
        return newItems
      })
      setEdited(true)
    },
    [items, setItems, setEdited]
  )

  const rearrange = useCallback(
    (index: number, direction: 'prev' | 'next') => {
      setItems((prevState) => {
        if (direction === 'prev') index -= 1
        prevState.splice(index, 2, prevState[index + 1], prevState[index])
        return [...prevState]
      })
      setEdited(true)
    },
    [setItems, setEdited]
  )

  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchBreads(storeRef, 'all'))
  }, [storeRef])

  const tabs = [
    {
      isSelected: page === 'daily',
      label: '当日取り置き',
      onClick: () => setPage('daily'),
      url: '/product/order',
    },
    {
      isSelected: page === 'preorder',
      label: '事前予約注文',
      onClick: () => setPage('preorder'),
      url: '/product/order',
    },
    {
      isSelected: page === 'delivery',
      label: '取り寄せ',
      onClick: () => setPage('delivery'),
      url: '/product/order',
    },
  ]

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'アプリでの並び順'} />
      <Spacer size={20} />
      <Description
        description={
          '商品を選択するか、移動するボタンを押して、並び変えたい場所へ移動してください。初期設定では、カテゴリー別で五十音順に表示されています。\n' +
          '商品が当日取り置き、事前予約、取り寄せそれぞれで登録されている場合は、片方を変更するともう片方にも反映されます。'
        }
      />
      <Spacer size={20} />
      <Tabs tabs={tabs} />
      <Spacer size={72} />
      <DndWrapper>
        <DndBreadList items={items} firstIndex={0} onMove={moveItem} rearrange={rearrange} page={page} />
      </DndWrapper>
      <Spacer size={48} />
      <OrangeButton
        disabled={!isEdited}
        label={'並び順を保存する'}
        onClick={() => dispatch(saveBreadsOrder(items))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <NavButton label={'sacriで出品する商品の管理に戻る'} iconPath={'/icon/grey/arrow_prev.svg'} url={'/product'} />
      <Spacer size={72} />
    </div>
  )
}

export default ProductOrderTemplate
